import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './AlbumsGrid.css';

const API_BASE = process.env.REACT_APP_PUBLIC_API_URL || 'http://localhost:3002/api/public';

// Helper function to convert album name to URL format (convert spaces to hyphens)
const albumNameToUrl = (albumName) => {
    return albumName ? albumName.replace(/\s+/g, '-').toLowerCase() : null;
};

function AlbumsGrid({ tenantName, tenant }) {
    const navigate = useNavigate();
    const hasAboutText = tenant?.about_text && tenant.about_text.trim().length > 0;
    const [albums, setAlbums] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchAlbums();
    }, [tenantName]);

    const fetchAlbums = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE}/${tenantName}/albums`);
            setAlbums(response.data);
            setError('');
        } catch (error) {
            console.error('Error fetching albums:', error);
            setError('Failed to load albums');
        } finally {
            setLoading(false);
        }
    };

    const handleAlbumClick = (album) => {
        const urlAlbumName = albumNameToUrl(album.name);
        navigate(`/${tenantName}/${urlAlbumName}`);
    };

    return (
        <div className="albums-grid-container">
            <header className="gallery-header">
                <h1>{tenant?.public_title || `${tenant?.name} Gallery`}</h1>
                <p className="gallery-subtitle">
                    {hasAboutText ? (
                        <Link to={`/${tenantName}/about`} className="about-link">About</Link>
                    ) : (
                        'Albums'
                    )}
                </p>
            </header>

            {error && <div className="error">{error}</div>}

            {loading ? (
                <div className="loading-albums">
                    <p>Loading albums...</p>
                </div>
            ) : albums.length === 0 ? (
                <div className="no-albums">
                    <p>No albums with published photos available yet.</p>
                </div>
            ) : (
                <div className="albums-grid">
                    {albums.map(album => (
                        <div
                            key={album.id}
                            className="album-card"
                            onClick={() => handleAlbumClick(album)}
                        >
                            <div className="album-cover">
                                {album.cover_photo_id ? (
                                    <img
                                        src={`${API_BASE}/${tenantName}/photos/${album.cover_photo_id}/thumbnail`}
                                        alt={album.name}
                                    />
                                ) : (
                                    <div className="no-cover">
                                        <span>No Cover</span>
                                    </div>
                                )}
                                <div className="album-overlay">
                                    <span className="view-album">View Album</span>
                                </div>
                            </div>
                            <div className="album-info">
                                <h3 className="album-name">{album.name}</h3>
                                {album.description && (
                                    <p className="album-description">{album.description}</p>
                                )}
                                <p className="album-photo-count">
                                    {album.photo_count} {parseInt(album.photo_count) === 1 ? 'photo' : 'photos'}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default AlbumsGrid;
